// =========================================
// Showcase — rotating heading word carousel
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    // Respect reduced-motion: leave the first word showing, don't cycle.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }
    document.querySelectorAll('.block-showcase__rotator').forEach(function (rot) {
        var words = Array.prototype.slice.call(rot.querySelectorAll('.block-showcase__rotate-word'));
        if (words.length < 2) {
            return;
        }
        var i = 0;
        setInterval(function () {
            words[i].classList.remove('is-active');
            i = (i + 1) % words.length;
            words[i].classList.add('is-active');
        }, 2200);
    });
});
